/* Original name @uswitch/trustyle.hero-secondary */
import React from 'react';
import { useThemeUI } from 'theme-ui';
import { Palette } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var makeStyles = function makeStyles(variant) {
  return function (element) {
    return "elements.hero".concat(variant ? ".variants.".concat(variant) : '').concat(element ? ".".concat(element) : '');
  };
};

var get = function get(obj, path, defaultValue) {
  // Potential vulnerability if coming from user data
  if (path.includes('__proto__')) {
    throw new Error('Not allowed to use __proto__ in paths');
  }

  var travel = function travel(regexp) {
    return String.prototype.split.call(path, regexp).filter(Boolean).reduce(function (res, key) {
      return res !== null && res !== undefined ? res[key] : res;
    }, obj);
  };

  var result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};

var DefaultContainer = function DefaultContainer(_ref) {
  var children = _ref.children;
  return _jsx("div", {
    sx: {
      maxWidth: 1024,
      margin: '0 auto',
      paddingX: 10
    },
    children: children
  });
};

var HeroSecondary = function HeroSecondary(_ref2) {
  var breadcrumbs = _ref2.breadcrumbs,
      _ref2$container = _ref2.container,
      Container = _ref2$container === void 0 ? DefaultContainer : _ref2$container,
      image = _ref2.image,
      _ref2$imageOnMobile = _ref2.imageOnMobile,
      imageOnMobile = _ref2$imageOnMobile === void 0 ? true : _ref2$imageOnMobile,
      _ref2$imageOnTablet = _ref2.imageOnTablet,
      imageOnTablet = _ref2$imageOnTablet === void 0 ? true : _ref2$imageOnTablet,
      _ref2$customBgColor = _ref2.customBgColor,
      customBgColor = _ref2$customBgColor === void 0 ? '' : _ref2$customBgColor,
      children = _ref2.children,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'secondary' : _ref2$variant,
      className = _ref2.className;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var styles = makeStyles(variant);
  var breadcrumbVariant = get(theme, styles('breadcrumbs.variant'));
  var breadcrumbWithVariant = breadcrumbs && /*#__PURE__*/React.cloneElement(breadcrumbs, {
    variant: breadcrumbVariant
  });
  return _jsx(Palette, {
    as: "div",
    sx: {
      overflow: 'hidden',
      variant: styles('wrapper')
    },
    px: {
      backgroundColor: 'backgroundColor'
    },
    children: _jsx("div", {
      sx: {
        position: 'relative',
        overflow: 'hidden',
        background: customBgColor || undefined
      },
      className: className,
      children: _jsxs(Container, {
        sx: {
          variant: styles('container')
        },
        children: [breadcrumbs && _jsx("div", {
          sx: {
            paddingTop: 'sm',
            variant: styles('breadcrumbs')
          },
          children: breadcrumbWithVariant
        }), _jsxs("div", {
          sx: {
            paddingTop: ['sm', 'xxl'],
            paddingBottom: ['sm', 'xxl'],
            display: 'flex',
            flexDirection: ['row', 'column'],
            variant: styles('content')
          },
          children: [image && // eslint-disable-next-line jsx-a11y/alt-text
          _jsx("img", {
            src: image,
            role: "presentation",
            sx: {
              display: [imageOnMobile ? 'block' : 'none', imageOnTablet ? 'block' : 'none', 'block'],
              variant: styles('image')
            }
          }), children]
        })]
      })
    })
  });
};

export default HeroSecondary;
//# sourceMappingURL=index.js.map